/**
 * Kit de Atendimento Types
 * Types for public Kit de Atendimento access
 *
 * @version 2025.1.0
 */

/**
 * Document available in the Kit
 */
export interface KitDocument {
  type: 'guide' | 'aso' | 'record';
  name: string;
  available: boolean;
  generatedAt?: string;
}

/**
 * Kit de Atendimento data returned by the API
 */
export interface KitData {
  appointment: {
    id: number;
    date: string;
    hour: string | null;
    minute: string | null;
    status: string;
  };
  employee: {
    name: string;
    cpf: string; // Masked for LGPD
  };
  company: {
    name: string;
  };
  examType: string;
  clinic: {
    name: string;
  } | null;
  documents: KitDocument[];
  expiresAt: string;
}

/**
 * Result of kit validation
 */
export interface KitValidationResult {
  valid: boolean;
  data?: KitData;
  error?: 'EXPIRED' | 'NOT_FOUND' | 'RATE_LIMITED' | 'UNKNOWN';
  message?: string;
}

/**
 * API response for kit data
 */
export interface KitApiResponse {
  message: string;
  data: KitData;
}

/**
 * Document type labels in Portuguese
 */
export const DOCUMENT_LABELS: Record<KitDocument['type'], string> = {
  guide: 'Guia de Atendimento',
  aso: 'ASO',
  record: 'Prontuario',
};
